import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ExperiencesScreen from '../screen'
import ExperienceRoutes from '../../experience/routes'

const ExperiencesRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.EXPERIENCES} component={ExperiencesScreen} />
            <ExperienceRoutes />
        </React.Fragment>
    )
}

export default ExperiencesRoutes